<template>
  <div :class="clsx(`calendar-header calendar-header--${size}`, { 'calendar-disabled': disableCalendar })">
    <button
      :disabled="disableCalendar"
      @click="$emit('navigate-month', -1)"
      class="nav-btn"
      aria-label="Previous month"
    >
      <OpenDownIcon class="prev" />
    </button>

    <div class="month-year-container">
      <span
        @click="$emit('toggle-month-selector')"
        class="month-display"
        aria-label="Toggle month selection"
      >
        {{ monthName }}
      </span>
      <span
        @click="$emit('toggle-year-selector')"
        class="year-display"
        aria-label="Toggle year selection"
      >
        {{ selectedYear }}
      </span>
    </div>

    <button
      :disabled="disableCalendar"
      @click="$emit('navigate-month', 1)"
      class="nav-btn"
      aria-label="Next month"
    >
      <OpenDownIcon class="next" />
    </button>
  </div>
</template>

<script>
import clsx from 'clsx';
import { OpenDownIcon } from '@/shared/ui/icons';

export default {
  props: {
    /**
     * If true, the calendar header controls (navigation, month/year selectors) are disabled.
     * @type {boolean}
     */
    disableCalendar: {
      type: Boolean,
      default: false,
    },
    /**
     * Defines the size of the calendar header.
     * @type {string}
     * @values 'normal', 'small'
     */
    size: {
      type: String,
      default: 'normal',
      validator: (value) => ['normal', 'small'].includes(value)
    },
    /**
     * The full name of the currently displayed month.
     * @type {string}
     * @required
     */
    monthName: {
      type: String,
      required: true,
    },
    /**
     * The currently selected year.
     * @type {number}
     * @required
     */
    selectedYear: {
      type: Number,
      required: true,
    },
  },
  components: { OpenDownIcon },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
$small-scale-factor: 0.8;
$header-month-year-font-size: 20px;
$header-nav-font-size: 20px;

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .month-year-container {
    display: flex;
    align-items: center;
    text-align: center;

    .month-display,
    .year-display {
      font-size: $header-month-year-font-size;
      font-weight: 600;
      text-transform: capitalize;
      cursor: pointer;
      padding: 4px 6px;
      transition: all 0.2s;
      color: #09090b;

      &:hover {
        background: #e0e0e0;
      }
    }
  }

  .nav-btn {
    background: none;
    border: none;
    font-size: $header-nav-font-size;
    cursor: pointer;
    transition: background-color 0.2s;
    padding: 7px 10px;

    &:hover {
      background-color: #e0e0e0;
    }

    .prev {
      transform: rotate(90deg);
      scale: 150%;
      color: #09090b;
    }

    .next {
      transform: rotate(-90deg);
      scale: 150%;
      color: #09090b;
    }
  }

  &--small {
    .month-year-container {
      .month-display,
      .year-display {
        font-size: $header-month-year-font-size * $small-scale-factor;
      }
    }

    .nav-btn {
      font-size: $header-nav-font-size * $small-scale-factor;
    }
  }

  &.calendar-disabled {
    .month-display,
    .year-display {
      color: #808080;
      pointer-events: none;
      cursor: default;
    }

    .nav-btn {
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
